import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a52eb9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-site-assigned-users bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = { class: "title-row pt-6 pb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Dipendenti aggiunti al cantiere", -1))
const _hoisted_7 = { class: "searchbar flex" }
const _hoisted_8 = { class: "users-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_WorkingSiteAssignedUser = _resolveComponent("WorkingSiteAssignedUser")!
  const _component_AssignUser = _resolveComponent("AssignUser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header w-full fixed relative inline-flex cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_LeftArrow, { class: "back-arrow" }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PrimaryButton, {
            class: "add-user text-primary block float-right text-white bg-primary-600 font-bold",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUserAssignmentDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aggiungi Dipendente")
            ]),
            _: 1
          }),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "text px-4 py-3 flex-grow",
            type: "text",
            placeholder: "Cerca dipendente",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-primary flex-none",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cerca")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createBlock(_component_WorkingSiteAssignedUser, {
              key: user.id,
              "user-id": user.id,
              "user-name": `${user.name} ${user.surname}`,
              onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search())),
              "working-site-id": _ctx.id,
              "working-site-name": _ctx.workingSite.name ?? '',
              "is-foreman": user.workSiteAssignments[_ctx.id].isForeman,
              "is-suspended": !user.workSiteAssignments[_ctx.id].isEnabled
            }, null, 8, ["user-id", "user-name", "working-site-id", "working-site-name", "is-foreman", "is-suspended"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.isShowingUserAssignment)
      ? (_openBlock(), _createBlock(_component_AssignUser, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideUserAssignmentDialog())),
          "working-site-id": _ctx.id
        }, null, 8, ["working-site-id"]))
      : _createCommentVNode("", true)
  ]))
}